// ITM/CM query parameters
export const breachIdQueryParamName = 'breachId';
export const sourceQueryParamName = 'source';
export const csidQueryParamName = 'csid';
export const currentUserCsidQueryParamName = 'currentUserCsid';
export const alertIdQueryParamName = 'alertId';
export const artifactIdQueryParamName = 'artifactId';
export const showBackButtonQueryParamName = 'showBackButton';
export const openDialogSourceQueryParamName = 'openDialogSource';
export const featureQueryParamName = 'feature';
export const emailTypeQueryParamName = 'emailType';
export const variantQueryParamName = 'variant';
export const showBulkAddDialogQueryParamName = 'showBulkAdd';

// ITM/CM query parameter values
export const loginQueryParamValue = 'login';

// Possible values for the feature query param
export type FeatureParam = 'itm' | 'cm';

// Ref sources
export const refSourceKey = 'refSource';
export const otsV2RefSource = 'otsv2';
